import { getOrganizationMembers } from '#pplx/frontend/apps/ask/queries/enterprise-queries/getOrganizationMembers.js';
import { getStoredRevisionToken } from '#pplx/frontend/apps/ask/rbac/hooks/revision-token/revisionToken.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
const MAX_SUGGESTIONS = 5;
export function normalizeUserMentionSearchQuery({ searchQuery, }) {
    return searchQuery?.trim() ?? '';
}
export function userMentionQueryOptions({ reason, searchQuery, orgUuid, enabled = true, }) {
    const normalizedSearchQuery = normalizeUserMentionSearchQuery({ searchQuery });
    return {
        queryKey: QueryClientHelper.makeEphemeralQueryKey('at-mention-users', orgUuid ?? 'none', normalizedSearchQuery),
        queryFn: () => getOrganizationMembers({
            limit: MAX_SUGGESTIONS,
            emailFilter: normalizedSearchQuery,
            memberType: 'members',
            reason,
            revisionToken: getStoredRevisionToken(orgUuid),
        }),
        enabled: enabled && normalizedSearchQuery.length > 0,
    };
}
//# sourceMappingURL=userMentionQueryOptions.js.map